// Autogenerated file
export const organizationDemoPeriodStatusesEnum = {
    Active: "Active",
    Expired: "Expired",
    Completed: "Completed",
};
export const organizationDemoPeriodStatuses = [
    { label: "Активный", value: "Active" },
    { label: "Истекший", value: "Expired" },
    { label: "Завершенный", value: "Completed" },
];
